import type { SVGProps } from "react";
export function RemoveCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m.833252 8.00004c0-3.95804 3.208628-7.166666 7.166668-7.166666 3.95808 0 7.16668 3.208626 7.16668 7.166666 0 3.95806-3.2086 7.16666-7.16668 7.16666-3.95804 0-7.166668-3.2086-7.166668-7.16666zm7.166668-6.16667c-3.40576 0-6.16667 2.76092-6.16667 6.16667 0 3.40576 2.76091 6.16666 6.16667 6.16666 3.40578 0 6.16668-2.7609 6.16668-6.16666 0-3.40575-2.7609-6.16667-6.16668-6.16667zm-3.02022 3.14645c.19526-.19526.51184-.19526.7071 0l2.31312 2.31309 2.31318-2.31309c.1952-.19526.5118-.19526.707 0 .1953.19526.1953.51185 0 .70711l-2.31305 2.31311 2.31305 2.31316c.1953.1952.1953.5118 0 .707-.1952.1953-.5118.1953-.707 0l-2.31318-2.31303-2.31312 2.31303c-.19526.1953-.51184.1953-.7071 0-.19526-.1952-.19526-.5118 0-.707l2.31308-2.31316-2.31308-2.31311c-.19526-.19526-.19526-.51185 0-.70711z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
